import type { Ref } from 'react';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { detectIfTruncated } from '../../common-functions';
import Input from '../../fields/input/input.component';
import Tooltip from '../../tooltip-component/tooltip.component';
import type { DataGridDataCellBaseProps } from '../data-grid-settings.interface';

export type DataGridDataTextCellProps = DataGridDataCellBaseProps<string | number | bigint> & {
  width?: number;
};

function DataGridDataTextCell(
  { value, isEditing = false, width }: DataGridDataTextCellProps,
  forwardRef: Ref<HTMLDivElement>
) {
  const cellRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useImperativeHandle(forwardRef, () => cellRef.current as HTMLDivElement);

  useEffect(() => {
    if (cellRef.current) {
      setIsTruncated(detectIfTruncated(cellRef.current));
    }
  }, [width]);

  const cellValue = value?.toString();

  return isEditing ? (
    <Input type="text" name={cellValue} value={cellValue} trimWhitespace={false} />
  ) : (
    <Tooltip
      description={cellValue}
      tooltipClassName="odin-bg-mono-1"
      disabled={!isTruncated}
      tooltipZIndexCheck={true}
    >
      {/*  NOTE: if modifying the padding 'odin-pl-2', please remember to update all other cells as well as 'CELL_PADDING_LEFT_PX' */}
      <div className="odin-pl-2 odin-truncate" data-testid="data-grid-cell-content" ref={cellRef}>
        {cellValue}
      </div>
    </Tooltip>
  );
}

export default forwardRef(DataGridDataTextCell);
